import { mutatorAction } from 'satcheljs';
import { getNotificationSettingsStore } from '../store/store';

let discardLocalSettingsChange = mutatorAction(
    'DISCARD_DESKTOP_NOTIFICATION_SETTINGS_CHANGE',
    () => {
        let store = getNotificationSettingsStore();
        store.settings = store.backupSettings;
        store.desktopNotificationSettingsDirty = false;
    }
);

export default discardLocalSettingsChange;
